import { render, staticRenderFns } from "./PostOpViewer.vue?vue&type=template&id=774e12a5&scoped=true"
import script from "./PostOpViewer.vue?vue&type=script&lang=js"
export * from "./PostOpViewer.vue?vue&type=script&lang=js"
import style0 from "./PostOpViewer.vue?vue&type=style&index=0&id=774e12a5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774e12a5",
  null
  
)

export default component.exports